<div style="margin-top: -2rem">
  <div class="filter--checkboxes">
    <c11n-checkbox-group>
      <c11n-checkbox
        *ngFor="let label of productTypeFilters"
        [labelText]="filterMap[label]"
        [variant]="'default'"
        [descriptiveLabel]="'Extra checkbox content'"
        [labelWeight]="'normal'"
      >
        <input
          c11nCheckboxInput
          [id]="label"
          type="checkbox"
          name="choices"
          [value]="label"
          [formControl]="productTypeGroup.controls[label]"
        />
      </c11n-checkbox>
    </c11n-checkbox-group>
  </div>
</div>

<section
  class="triggerWrapper"
  role="application"
  *ngIf="isMutualFundsSelected"
  style="margin-bottom: 24px"
>
  <b>Fund family</b>
  <div class="space"><br />{{ fundFamilySelection }}<br /></div>
  <a
    href="javascript:void(0)"
    role="button"
    class="link"
    aria-label="Change Fund Family"
  ></a>

  <button
    id="modalTrigger-basic"
    type="button"
    class="c11n-button c11n-button--medium c11n-button--primary"
    (click)="openModal()"
  >
    <span class="link">Change</span>
  </button>
</section>

<div id="entrypoint" class="c11n-modal-dialog-entrypoint">
  <dialog id="constellationDialog-basic" class="c11n-modal-dialog">
    <!--    scrollable content-->
    <div class="c11n-modal-dialog-document c11n-modal-dialog-document--basic">
      <button
        id="sendFocusToBottom"
        aria-hidden="true"
        class="c11n-modal-dialog-document__sendFocusToBottom"
      >
        Set focus to last button
      </button>

      <span class="c11n-modal-dialog-document__close">
        <button
          id="modalCloseButton"
          type="button"
          aria-label="close modal,  Take action"
          title="close modal,  Take action"
          class="c11n--on-light c11n-button c11n-button--icon-ghost c11n-button--small"
          (click)="closeModal()"
        >
          <span class="c11n-button__box">
            <span class="c11n-button__icon-only">
              <svg role="img" class="c11n-remove-small">
                <title>close modal, Take action</title>
                <use href="#remove-small"></use>
              </svg>
            </span>
          </span>
        </button>
      </span>

      <!--header content-->
      <div class="c11n-modal-dialog-document__header">
        <h1 id="modalTitle1">Fund family</h1>

        <c11n-search
          #searchComponent
          labelText="Find fund family"
          [hideLabel]="true"
          [hideSearchButton]="false"
          placeHolderText="Find fund family"
          (stateChange)="handleSearch($event)"
          class="c11n-modal-dialog-document__header__input"
        >
        </c11n-search>
      </div>

      <div
        class="c11n-modal-dialog-document__header c11n-modal-dialog-document__header--secondary-header"
      >
        <div
          class="c11n-modal-dialog-document__radio-button--isolated"
          style="margin-bottom: 15px"
        >
          <c11n-radio-group
            (stateChange)="getRadioButton($event)"
            [groupId]="'fundFamilies'"
            [legendText]="'Select a fund family'"
            [hideLegend]="true"
          >
            <c11n-radio
              labelText="Vanguard"
              descriptiveLabel="'Vanguard'"
              style="display: block; margin-top: 1rem; width: 100%"
            >
              <input
                c11nRadioInput
                id="vanguard"
                type="radio"
                name="choices"
                value="choice1"
                [checked]="fundFamilySelection === 'Vanguard'"
                style="width: 100%"
              />
            </c11n-radio>
          </c11n-radio-group>
        </div>
      </div>

      <div
        class="c11n-modal-dialog-document__content c11n-link--reinforced c11n-text-md"
        id="modalContent"
        style="max-height: 440px"
      >
        <ng-container *ngIf="fundFamilyDetails && fundFamilyDetails.length; else noMatches">
          <c11n-radio-group
            (stateChange)="getRadioButton($event)"
            [groupId]="'fundFamilies'"
            [legendText]="'Select a fund family'"
            [hideLegend]="true"
          >
            <c11n-radio
              *ngFor="let family of fundFamilyDetails"
              [labelText]="
                family.fundFamilyName +
                (family.hasLoadFunds ? ' [Load]' : '') +
                (family.hasNTFFunds ? ' [NTF]' : '')
              "
            >
              <input
                c11nRadioInput
                [id]="family.fundFamilyId"
                type="radio"
                name="choices"
                [value]="family.fundFamilyId"
                [checked]="
                  fundFamilySelection ===
                  family.fundFamilyName +
                    (family.hasLoadFunds ? ' [Load]' : '') +
                    (family.hasNTFFunds ? ' [NTF]' : '')
                "
              />
            </c11n-radio>
          </c11n-radio-group>
        </ng-container>

        <ng-template #noMatches>
          <div class="empty-state">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 21.9675C14.6435 21.9675 17.1788 20.9173 19.0481 19.0481C20.9173 17.1788 21.9675 14.6435 21.9675 12C21.9675 9.35643 20.9173 6.82115 19.0481 4.95188C17.1788 3.08261 14.6435 2.03247 12 2.03247C9.35643 2.03247 6.82115 3.08261 4.95188 4.95188C3.08261 6.82115 2.03247 9.35643 2.03247 12C2.03247 14.6435 3.08261 17.1788 4.95188 19.0481C6.82115 20.9173 9.35643 21.9675 12 21.9675Z"
                stroke="black"
                stroke-width="1.85"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 17.5375V13.1075"
                stroke="black"
                stroke-width="1.85"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 8.74397C11.8532 8.74397 11.7123 8.68563 11.6085 8.58178C11.5046 8.47794 11.4463 8.33709 11.4463 8.19022C11.4463 8.04336 11.5046 7.90251 11.6085 7.79866C11.7123 7.69482 11.8532 7.63647 12 7.63647"
                stroke="black"
                stroke-width="1.85"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 8.74397C12.1469 8.74397 12.2877 8.68563 12.3916 8.58178C12.4954 8.47794 12.5538 8.33709 12.5538 8.19022C12.5538 8.04336 12.4954 7.90251 12.3916 7.79866C12.2877 7.69482 12.1469 7.63647 12 7.63647"
                stroke="black"
                stroke-width="1.85"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <span
              class="empty-state__text"
              aria-label="No matches results found. Try adjusting your search"
            >
              No matches results found. Try adjusting your search
            </span>
          </div>
        </ng-template>
      </div>

      <!--      footer content-->
      <div
        class="c11n-modal-dialog-document__footer"
        style="margin-top: 35px; margin-bottom: -5px"
      >
        <button
          id="modalFooterButton1"
          type="button"
          class="c11n-button c11n-button--medium c11n-button--primary"
          (click)="applyButton($event); closeModal()"
        >
          <span class="c11n-button__box">
            <span class="c11n-button__label">Apply</span>
          </span>
        </button>
        <button
          id="modalFooterButton2"
          type="button"
          class="c11n-button c11n-button--medium c11n-button--secondary"
          (click)="closeModal()"
        >
          <span class="c11n-button__box">
            <span class="c11n-button__label">Cancel</span>
          </span>
        </button>
      </div>
      <button
        id="sendFocusToTop"
        aria-hidden="true"
        class="c11n-modal-dialog-document__sendFocusToTop"
      >
        Set focus to close button
      </button>
    </div>
  </dialog>
</div>
